import React from 'react'
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const S3progress = ({
    progress,
    timeRemaining,
    uploadSpeed,
    totalFiles,
    uploadedFiles,
    totalSize,
    uploadedSize
}) => {

    // const formatTime = (seconds) => {
    //     if (!seconds || seconds < 0) return "Calculating...";

    //     const hours = Math.floor(seconds / 3600);
    //     const minutes = Math.floor((seconds % 3600) / 60);
    //     const remainingSeconds = Math.floor(seconds % 60);

    //     if (hours > 0) {
    //         return `${hours}h ${minutes}m remaining`;
    //     } else if (minutes > 0) {
    //         return `${minutes}m ${remainingSeconds}s remaining`;
    //     }
    //     return `${remainingSeconds}s remaining`;
    // };

    // const formatSpeed = (speed) => {
    //     if (!speed || speed === 0) return "Calculating...";

    //     if (speed < 1) {
    //         return `${(speed * 1024).toFixed(0)} KB/s`;
    //     }
    //     return `${speed.toFixed(1)} MB/s`;
    // };

    // const formatFileSize = (bytes) => {
    //     if (!bytes) return "0 B";

    //     const sizes = ['B', 'KB', 'MB', 'GB'];
    //     const i = Math.floor(Math.log(bytes) / Math.log(1024));
    //     return `${(bytes / Math.pow(1024, i)).toFixed(1)} ${sizes[i]}`;
    // };
    return (
        <div>
            <Box sx={{ width: '100%', p: 2 }}>
                {/* Main Progress Bar */}
                <Box sx={{ width: '100%', mb: 2 }}>
                    <LinearProgress
                        variant="determinate"
                        value={progress}
                        sx={{
                            height: 8,
                            borderRadius: 4,
                            backgroundColor: 'rgba(0,0,0,0.1)',
                            '& .MuiLinearProgress-bar': {
                                borderRadius: 4,
                                backgroundColor: progress === 100 ? '#20409A' : '#20409A',
                            }
                        }}
                    />
                </Box>

                {/* Progress Percentage */}

                <Stack spacing={2}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                        <Typography color="#20409A" fontWeight="bold">
                            {progress}%
                        </Typography>
                    </Box>
                    {/* Time and Speed Row */}
                    {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Chip
                            label={formatTime(timeRemaining)}
                            variant="outlined"
                            color="primary"
                            size="small"
                            sx={{ fontSize: '0.75rem' }}
                        />
                        <Chip
                            label={formatSpeed(uploadSpeed)}
                            variant="outlined"
                            color="secondary"
                            size="small"
                            sx={{ fontSize: '0.75rem' }}
                        />
                    </Box> */}

                    {/* Files Progress */}
                    {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body2" color="text.secondary">
                            Files: {uploadedFiles} / {totalFiles}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {formatFileSize(uploadedSize)} / {formatFileSize(totalSize)}
                        </Typography>
                    </Box> */}

                    {/* Status Message */}
                    {/* <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ textAlign: 'center', fontStyle: 'italic' }}
                    >
                        {progress === 100 ?
                            "Upload completed successfully!" :
                            "Uploading images to S3..."
                        }
                    </Typography> */}
                </Stack>
            </Box>
        </div>
    )
}

export default S3progress